<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="특장점 안내" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>특장점 안내</template>
            <v-row class="row--xxs">
                <template v-for="(item, index) in items">
                    <v-col :key="index" cols="12" sm="6" xl="3">
                        <v-img :src="item.icon" class="feature-icon" />
                        <tit class="tit--sm text-center mb-20px mb-md-34px">
                            {{ item.name }}
                        </tit>
                        <v-sheet color="grey lighten-5 pa-16px feature-sheet">
                            <txt class="text-pre-wrap txt--lg grey--text break-keep line-height-15">
                                <template v-for="(child, index) in item.children">
                                    <v-row :key="index" class="row--xxs">
                                        <v-col cols="auto">·</v-col>
                                        <v-col>{{ child }}</v-col>
                                    </v-row>
                                </template>
                            </txt>
                        </v-sheet>
                    </v-col>
                </template>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        Tit,
        Txt,
    },
    data: () => ({
        items: [
            {
                icon: "/images/sub/business/feature/feature-1.svg",
                name: "교통",
                children: [
                    "CBD까지 20분 내 소요",
                    "길음역, 미아사거리역 4호선 도보",
                    "동북선 숭곡초교역 26년 7월\r\n개통예정",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-2.svg",
                name: "생활",
                children: [
                    "맘스카페, 스터디룸, 공유주방, 코인 세탁실 등 다양한 커뮤니티 시설 구비",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-3.svg",
                name: "인프라",
                children: [
                    "현대백화점, 롯데백화점,이마트 근접",
                    //
                ],
            },
            {
                icon: "/images/sub/business/feature/feature-4.svg",
                name: "자연",
                children: [
                    "북서울꿈의숲, 오동공원 차량 10분",
                    //
                ],
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.feature-icon {
    max-width: 60px;
    margin: 30px auto 10px;
}
@media (min-width: 768px) {
    .feature-icon {
        max-width: 80px;
    }
    .feature-sheet {
        min-height: 156px;
    }
}
</style>
